<template>
    <div class="store">
        <div class="shop-top">
            <a href="javascript:" class="shop-top-return" @click="closeShopPanel">返回</a>
            <input
                type="text"
                class="bk-form-input bk-input-search"
                placeholder="搜索"
                v-model='searchVal'
                @keyup.enter="doFilter"
                @click="doFilter">
        </div>
        <div class="shop-content" v-if="isGetAllLoading" style="text-align: center;padding-top: 100px">
            <img src="../../images/common/loading_2_24x24.gif" alt="" />
        </div>
        <!-- 商城数据不为空 -->
        <template v-if="allList.length !== 0 && !isGetAllLoading">
            <div
                class="shop-content"
                v-for="(pItem, pIndex) in allList"
                :key="pIndex">
                <h2>{{ pItem.text }}</h2>
                <ul class="shop-list">
                    <li
                        v-for="(lItem, lIndex) in allList[pIndex].items"
                        :key="lIndex"
                        @mouseenter="showBack(pIndex, lIndex)"
                        @mouseleave="hideBack(pIndex, lIndex)">
                        <div class="shop-list-img">
                            <img :src="lItem.logo" alt="">
                        </div>
                        <div class="shop-list-name">
                            <span class="new-tip" v-if="lItem.is_new">新品</span>
                            {{ lItem.title }}
                        </div>
                        <div class="shop-list-money">
                            {{ lItem.min_price }}
                        </div>
                        <div :class="['shop-list-back',{'on':isBackShow === true && lIndex === curShopIndex && pIndex === curKeyIndex}]">
                            <button type="button" class="bk-button bk-primary" title="购买" @click='openOrder(pIndex,lIndex)'>
                                <span>购买</span>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </template>
        <!-- 商城数据为空 -->
        <div class="shop-content" v-if="allList.length === 0 && !isGetAllLoading">
            <div class="bk-message-box">
                <p>暂时没有数据</p>
            </div>
        </div>
        <!-- 购买商品 -->
        <o-alert
            ref="oAlert"
            :orderOptions="orderOptions"
            :shopDetail="shopDetail"
            :bkb="bkb"
            v-on:changeData="showShopPanel"
            v-on:changeMoney="getBalance">
        </o-alert>
    </div>
</template>

<script>
import order from "../order.vue"
import bus from '@/js/bus.js'
export default {
    components: {
        "o-alert": order
    },
    props: {
        bkb: {
            type: Object
        }
    },
    data () {
        return {
            searchVal: '',
            allList: [],
            isBackShow: false,
            curShopIndex: -1,
            curKeyIndex: -1,
            userBalance: {
                bkb: 0,
                rmb: "0.00"
            },
            isGetAllLoading: false,
            orderOptions: {
                orderId: "",
                isOrderShow: false
            },
            shopDetail: [],
        }
    },
    watch: {
        bkb: {
            handler (val) {
                this.userBalance = val
            },
            immediate: true
        },
        searchVal (val) {
            if (val === '') {
                this.doFilter()
            }
        }
    },
    mounted () {
        this.showShopPanel()
    },
    methods: {
        /*
        ** 百度统计
        */
        goTrack(url, status, action) {
            _hmt.push(['_trackPageview', url])
            _hmt.push(['_trackEvent', action, 'click'])
            if (status) {
                this.$router.push({
                    path: url
                })
            }
        },
        closeShopPanel () {
            this.searchVal = ''
            this.goTrack('/s-mart/personal_center/', true, 'user-center-mallback')
        },
        doFilter () { //搜索框
            let searchVal = this.searchVal
            // 展示分类商品
            axios.post(myUrl + "market/gift/get_all/", qs.stringify({
                'search' : searchVal
            })).then(res => {
                let resData = res.data
                if(resData.result) {
                    this.allList = resData.data
                }
            })
        },
        showBack (index1,index2) {
            this.isBackShow = true
            this.curKeyIndex = index1
            this.curShopIndex = index2
        },
        hideBack (index1, index2) {
            this.isBackShow = false
            this.curShopIndex = -1
            this.curKeyIndex = -1
        },
        openOrder (pIndex,lIndex) {
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup');
                return;
            }
            this.orderOptions.isOrderShow = true
            this.shopDetail = this.allList[pIndex].items[lIndex]
            this.goTrack('', false, 'user-center-mall-buy')
            this.$nextTick(() => {
                this.$refs.oAlert.priceComputeResult = ''
            })
        },
        showShopPanel () {
            this.isGetAllLoading = true
            this.goTrack('', false, 'user-center-mall ')

            // 展示分类商品
            axios.post(myUrl + "market/gift/get_all/",qs.stringify({
                'search' : ''
            })).then((res) => {
                let resData = res.data
                if(resData.result) {
                    this.isGetAllLoading = false
                    this.allList = resData.data
                }
            })
        },
        // 用户余额
        getBalance() {
            this.$emit('getBalance')
        }
    }
}
</script>

<style lang="scss" scoped>
    .shop-top {
        display: block;
        border-bottom: solid 1px #f4f4f4;
        &-return {
            width: 94px;
            display: inline-block;
            text-align: center;
            padding: 20px 0;
            color: #4f515e;
            border-right: solid 1px #f4f4f4;
            &:hover {
                color: #57a3f1;
        }
        }
    }
    .shop-content {
        padding: 30px 45px;
        border-top: solid 1px #f4f4f4;
        margin-top: -1px;
        h2{
            padding-left: 15px;
            line-height: 18px;
            height: 18px;
            font-size: 14px;
            color: #4f515e;
            position: relative;
            &:before {
                content: "";
                display: inline-block;
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                height: 18px;
                background: #57a3f1;
            }
        }
        .shop-list {
            display: flex;
            flex-wrap: wrap;
            margin-left: -10px;
            margin-right: -10px;
            li {
                width: 148px;
                // overflow-x: hidden;
                margin: 30px 10px 0 10px;
                text-align: center;
                position: relative;
                .shop-list-img {
                    width: 146px;
                    height: 110px;
                    border: solid 1px #e6e6e7;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .shop-list-name {
                    padding: 9px 0 12px 0;
                    .new-tip {
                        display: inline-block;
                        text-align: center;
                        line-height: 16px;
                        background: #e4faf0;
                        color: #14a568;
                        border-radius: 12px;
                        padding: 3px 5px;
                    }
                }
                .shop-list-money {
                    padding: 0 10px 0 28px;
                    background: #eaeaea;
                    border-radius: 10px;
                    display: inline-block;
                    font-size: 14px;
                    line-height: 24px;
                    position: relative;
                    &:before {
                        content: "";
                        display: inline-block;
                        position: absolute;
                        left: 8px;
                        top: 5px;
                        width: 14px;
                        height: 14px;
                        background: url(../../images/personal_center/icon-money2.png);
                    }
                }
                .shop-list-back {
                    opacity: 0;
                    -moz-transition: opacity 0.3s;
                    -ms-transition: opacity 0.3s;
                    -webkit-transition: opacity 0.3s;
                    transition: opacity 0.3s;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 146px;
                    height: 110px;
                    background: rgba(0,0,0,0.5);
                    &.on {
                        opacity: 1;
                    }
                    .bk-primary {
                        height: 32px;
                        line-height: 32px;
                        margin: 40px auto;
                        float: none;
                    }
                }
            }
        }
    }
    .bk-input-search {
        width: 288px;
        margin-left: 20px;
        padding-left: 40px;
        background: url(../../images/personal_center/icon-search.png) 10px 8px no-repeat;
        cursor: pointer;
    }
    .bk-message-box {
        width: 100%;
        text-align: center;
        padding: 50px 0;
        color: #a6a6a6;
    }
</style>



// WEBPACK FOOTER //
// store.vue?1d849d16